import axios from "axios";
import { Toast } from 'antd-mobile';
import { dispatchSDK } from "./extend";

const isProd = process.env.NODE_ENV === 'production'

const service = axios.create({
  baseURL: isProd ? window.Base_Config.baseURL : 'http://user-cn.51shaha.com/'
});

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    const extendParams = config.params || {};
    extendParams.token = token;
    config.params = extendParams;
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    const { code, msg } = response.data
    if (code === 401) {
      dispatchSDK('loginFailure');
      return Promise.reject();
    }
    if (code !== 200) {
      setTimeout(() => {
        Toast.show(msg || '请求出错', 2);
      }, 0);
      return Promise.reject();
    }
    return response.data;
  },
  error => {
    setTimeout(() => {
      Toast.offline('网络出错', 2);
    }, 0);
    return Promise.reject(error);
  }
);

export default service;
